



const serialize = (obj) => obj === undefined
	? undefined
	: JSON.parse(JSON.stringify(obj))

exports.createSendMessageSystem = () => {
	return {
		send: (message, params) => {
			const event = new CustomEvent(message, {
				detail: {
					params: serialize(params),
					token: context.API_TOKEN,
				},
			})
			document.dispatchEvent(event)
		},
	}
}



// WEBPACK FOOTER //
// ./djangosite/master/frontend/src/search-panel/sendMessageSystem.js